import { render } from "./PaymentScreen.vue?vue&type=template&id=5065de16&scoped=true&ts=true"
import script from "./PaymentScreen.vue?vue&type=script&lang=ts"
export * from "./PaymentScreen.vue?vue&type=script&lang=ts"

import "./PaymentScreen.vue?vue&type=style&index=0&id=5065de16&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5065de16"]])

export default __exports__